import { render, staticRenderFns } from "./InfoMercadoVarejoPage.vue?vue&type=template&id=3228447a&"
import script from "./InfoMercadoVarejoPage.vue?vue&type=script&lang=js&"
export * from "./InfoMercadoVarejoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports